import * as React from 'react';
import { SiteUrlsProps } from '../../app/selectors/SiteUrlsSelectors';
import { DatasourceMetadata, ModifiedDateMetadata, OwnerMetadata } from '../../app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon } from '../../app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '../../app/spaces/Header/SpaceHeader';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { ILensActions } from '../../ts/ServerApi/types/ILensAction';
import { RadioEditProvider } from '../../dataRole/utils/RadioEditProvider';
import { EditableLensDescriptionInline } from './LensHeaderEditableDescription';
import { ISanitizer } from '../../commonInfra/utils/Sanitize';
import { SpaceHeaderStyles } from '../../../src/app/spaces/Header/SpaceHeaderStyles';
import { EditableLensName } from './LensHeaderEditableName';

export interface LensSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'lens'>;
  readonly availableActions: ILensActions;
  readonly canEdit: boolean;
  readonly isAdminOrOwner?: boolean;
  readonly sanitizer: ISanitizer;
  readonly reloadSpace: () => void;
}

export function LensSpaceHeader(props: LensSpaceHeaderProps): JSX.Element {
  const canEditLens = props.canEdit;
  const [ editingName, setEditingName ] = React.useState(false);
  const [ editingDescription, setEditingDescription ] = React.useState(false);

  const onNameEdit = (isEditing: boolean) => {
    setEditingName(isEditing);
  };
  const onDescriptionEdit = (isEditing: boolean) => {
    setEditingDescription(isEditing);
  };

  return <RadioEditProvider isReadonly={!canEditLens}>
    <ConnectedSpaceHeader
      item={props.item}
      nameRowIcons={
        <>
          {ActionsMenuIcon(props.item)}
        </>
        }
      availableActions={props.availableActions}
      nameElement={<EditableLensName {...props} canEdit={canEditLens && !editingDescription} onEditChange={onNameEdit}/>}
      descriptionElement={<EditableLensDescriptionInline {...props} canEdit={canEditLens && !editingName} onEditChange={onDescriptionEdit}/>}
      metadataRow={
        <React.Fragment>
          { OwnerMetadata(props.item.owner, props.urls) }
          { ModifiedDateMetadata(props.item.updatedAt) }
          { DatasourceMetadata(props.item.datasource, props.urls) }
        </React.Fragment>
      }
    />
  </RadioEditProvider>;
}
